import { Link } from "react-router-dom";
import flavia01 from "../images/flavia01.jpeg";
import { useEffect } from "react";

function Home() {
  return (
    <div className="min-h-[80vh] flex flex-col justify-center">
      <div className="max-w-4xl mx-auto text-center">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div>
            <img
              src="https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?auto=format&fit=crop&w=1200&q=80"
              alt="Grand Piano"
              className="w-full h-[400px] object-cover rounded-lg shadow-2xl"
            />
          </div>
          <div>
            <img
              src={flavia01}
              alt="Flavia at the Piano"
              className="w-full h-[400px] object-cover object-top rounded-lg shadow-2xl"
            />
          </div>
        </div>
        <h1 className="text-6xl font-bold mb-6">Flavia Karla Amado León</h1>
        <p className="text-xl text-piano-black/80 mb-8">
          Experience the passion and artistry of classical piano performance
        </p>
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 justify-center">
          <Link
            to="/performances"
            className="btn btn-primary w-full sm:w-auto text-center"
          >
            View Performances
          </Link>
          <Link
            to="/contact"
            className="btn border border-piano-black hover:bg-piano-black hover:text-ivory w-full sm:w-auto text-center"
          >
            Get in Touch
          </Link>
        </div>

        <div className="mt-20 mb-20">
          <h2 className="text-4xl font-serif mb-8">Featured Performance</h2>
          <div className="max-w-[400px] mx-auto">
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <iframe
                className="w-full aspect-[9/16] rounded-lg"
                src="https://cdn.shopify.com/videos/c/o/v/85d3ddffe3e8432c84b869a7de4e524a.mp4"
                title="Piano Performance by Flavia Karla Amado León"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center p-6 bg-ivory shadow-lg rounded-lg transition duration-300 hover:shadow-xl hover:bg-ivory/90">
        <Link to="/repertoire" className="block h-full">
          <h3 className="text-2xl font-serif mb-4">Repertoire</h3>
          <p className="text-piano-black/70">
            Explore my diverse collection of classical pieces
          </p>
        </Link>
      </div>
    </div>
  );
}

export default Home;
